<template>
  <v-dialog 
    :value="dialog" 
    persistent 
    max-width="800px">
    <v-card>
      <v-form 
        v-if="item && item.type == 'selectblock'"
        ref="form"
        v-model="valid"              
        lazy-validation>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>
            <span class="headline">Add select</span>            
          </v-toolbar-title>
        </v-toolbar>
        <v-card 
          v-show="item.label || item.options.length > 0" 
          color="yellow lighten-5">
          <v-card-text>
            <v-select                  
              :items="item.options"       
              :label="item.label"
              :hint="item.hint"
              :persistent-hint="item.persistantHint"
              :required="item.required"
            />
          </v-card-text>     
        </v-card>       
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="item.label"
                  :rules="labelRules"
                  label="Label"                                           
                  required
                  hint="Label for text field"  
                />
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-card-title>
                    <h4>Options</h4>
                    
                  </v-card-title>
                  <v-divider/>                  
                  <v-card-actions 
                    v-for="(val, i) in item.options"
                    :key="i">
                    <v-text-field
                      v-model="item.options[i]"
                      append-icon="clear"
                      @click:append="removeOption(i)"
                      :rules="[
                        v => !optionChecker() || 'Duplicate value',
                        v => !v || (!!v && v.length < 30) || 'Must be less than 30 characters'
                      ]"
                    />                      

                  </v-card-actions>
                  <v-btn 
                    absolute
                    fab 
                    bottom
                    right
                    dark 
                    color="primary" 
                    @click="addOption()">
                    <v-icon 
                      dark>add</v-icon>
                  </v-btn> 
                </v-card>
              </v-flex>
              
              <v-flex xs12>
                <v-text-field
                  v-model="item.hint"
                  :rules="[
                    v => !v || v.length < 100 || 'Text must be less than 100 characters'
                  ]"
                  label="Hint"                                           
                  hint="Hint appears under text field when selected or always if persistant"  
                />
              </v-flex>
              <v-flex xs12>
                <v-checkbox 
                  v-model="item.persistantHint" 
                  label="Persistant hint (always show hint)"/>
              </v-flex>
              <v-flex xs12>
                <v-radio-group 
                  v-model="item.required"
                  persistent-hint
                  hint="Is the text field mandatory"
                  row 
                >
                  <v-radio
                    :value="true"
                    label="Required"                      
                    color="primary" 
                  />
                  <v-radio
                    :value="false"
                    label="Optional"                      
                    color="primary" 
                  />
                </v-radio-group>                
              </v-flex>            
              <v-flex xs12>
                <v-radio-group 
                  v-model="item.show"
                  persistent-hint
                  hint="Should the element be displayed when editing a form or always"
                  row 
                >
                  <v-radio
                    :value="true"
                    label="Show always"                      
                    color="primary" 
                  />
                  <v-radio
                    :value="false"
                    label="Show in form"                      
                    color="primary" 
                  />
                </v-radio-group>                
              </v-flex>
              <v-flex xs12>
                <v-checkbox 
                  v-model="item.csv" 
                  label="Include element in CSV"/>
              </v-flex>
              <v-flex 
                xs12 
                v-if="item.csv"> 
                <v-btn 
                  v-if="suggestedKey && suggestedKey != item.csvKey" 
                  block
                  @click="item.csvKey = suggestedKey"
                  :value="suggestedKey">Use key: "{{ suggestedKey }}"</v-btn>              
                <v-text-field
                  :rules="csvRules"
                  v-model="item.csvKey"                  
                  label="CSV key"  
                  persistent-hint
                  hint="CSV headers are generated from these Keys and must be unique"
                />                
              </v-flex>             
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn 
            color="primary" 
            flat 
            @click.native="close">Close</v-btn>
          <v-btn 
            v-if="selectitem.label" 
            color="red darken-1" 
            flat 
            @click.native="remove()">Delete</v-btn>         
          <v-btn 
            color="primary" 
            flat 
            @click.native="save(item)">{{ (selectitem.label ? 'Update' : 'Save') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Selectblock",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selectitem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      valid: true,
      checkbox: null,
      showOptions: "show",
      optionLabel: "",
      labelRules: [
        v => !!v || "Required",
        v => (!!v && v.length < 100) || "Text must be less than 100 characters"
      ],
      csvRules: [
        v => !!v || "Required",
        v => /^[a-zA-Z0-9_]+$/.test(v) || "Alphanumeric and underscore"
      ],
      item: null
    };
  },
  watch: {
    selectitem: function(val) {
      this.item = JSON.parse(JSON.stringify(val));
    }
  },
  computed: {
    suggestedKey: function() {
      if (this.item && this.item.label) {
        return this.item.label
          .replace(/\s+/g, "_")
          .replace(/[^a-zA-Z0-9_]/g, "")
          .toUpperCase();
      }
      return null;
    }
  },
  methods: {
    optionChecker() {
      return new Set(this.item.options).size !== this.item.options.length;
    },
    addOption() {
      this.item.options.push("");
    },
    removeOption(index) {
      this.item.options.splice(index, 1);
    },
    save(item) {
      if (this.$refs.form.validate()) {
        this.$emit("statusDialog", false);
        this.$emit("saveItem", item);
        this.$store.dispatch("setLoading", true);
      }
    },
    remove() {
      this.$emit("statusDialog", false);
      this.$emit("saveItem", null);
      this.$store.dispatch("setLoading", true);
    },
    close() {
      this.$emit("statusDialog", false);
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "warning",
        text: "Input not saved"
      });
    }
  }
};
</script>
